import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito seguidores para empezar?',
    a: 'No. El UGC de marca no requiere publicar nada en tus redes. Creas el video, envías el archivo y cobras. Tus seguidores no importan.'
  }, {
    q: '¿Necesito equipo especial o cámara cara?',
    a: 'No. Un móvil de menos de 5 años es suficiente. En el Tomo 2 aprendes a configurarlo para producir contenido de calidad profesional.'
  }, {
    q: '¿Cuánto tiempo tengo que dedicar al día?',
    a: 'Con 1-2 horas diarias es suficiente para empezar. El sistema de batching del Tomo 5 te permite producir una semana entera de contenido en 2 horas de grabación.'
  }, {
    q: '¿Cuándo veré los primeros ingresos?',
    a: 'El plan realista dice entre el día 15 y el día 45 para el primer proyecto cobrado. Depende directamente de cuántos días apliques el sistema de prospección.'
  }, {
    q: '¿Es legal en España?',
    a: 'Sí. La guía del Pack Acelerador Pro explica exactamente cómo gestionar los ingresos de forma legal desde el primer euro, incluyendo los umbrales de autónomo y las opciones de facturación.'
  }, {
    q: '¿Qué pasa si no me gusta el producto?',
    a: 'Tienes 30 días de garantía total. Si no estás satisfecho por cualquier razón, te devolvemos el 100% sin preguntas.'
  }, {
    q: '¿El producto está en español?',
    a: 'Sí. Todo el contenido está íntegramente en español y orientado específicamente al mercado español.'
  }, {
    q: '¿Cómo accedo al producto tras la compra?',
    a: 'Inmediatamente después del pago recibes un email con los links de descarga de todos los PDFs. Acceso instantáneo, sin esperas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-white py-20 px-4" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        <div className="text-center mb-10" data-id="element-95">
          <span className="text-neon font-bold text-sm tracking-widest uppercase bg-black px-4 py-1 rounded-full" data-id="element-96">
            — RESOLVEMOS TUS DUDAS —
          </span>
        </div>

        <div className="space-y-4" data-id="element-97">
          {faqs.map((faq, index) => <div key={index} className={`border-2 rounded-xl overflow-hidden transition-colors duration-300 ${openIndex === index ? 'border-neon bg-gray-50' : 'border-gray-200 bg-white'}`} data-id="element-98">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => toggleFaq(index)} data-id="element-99">
                <span className="font-bold text-lg text-black pr-8" data-id="element-100">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-6 h-6 text-neon shrink-0" data-id="element-101" /> : <ChevronDown className="w-6 h-6 text-gray-400 shrink-0" data-id="element-102" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-103">
                <p className="text-gray-700 text-lg border-t border-gray-200 pt-4" data-id="element-104">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}